import { render, staticRenderFns } from "./OrderStages.vue?vue&type=template&id=cf7cc520&"
import script from "./OrderStages.vue?vue&type=script&lang=js&"
export * from "./OrderStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports